import React from 'react'
import styles from './styles/common-competitors.module.scss'
import h2hStyles from './styles/h2h.module.scss'
import i18n from 'constants/strings'
import { Player } from 'types/global'
import { Flag } from 'components/generic/Country'
import { getProfileUrl, isPlayerHidden } from 'utils'
import OptedOutPlayer from 'components/profile/generic/OptedOutPlayer'

interface Props {
  players: [Player, Player]
  tableData: any
  visibleCompetitorsInCommon: number
  totals: {
    p1TotalWinPc: number
    p2TotalWinPc: number
    p1TotalWin: number
    p1TotalLoss: number
    p2TotalWin: number
    p2TotalLoss: number
  }
  setVisibleCompetitorsInCommon: React.Dispatch<React.SetStateAction<number>>
}

const H2HCommonCompetitorsDesktop: React.FC<Props> = ({
  players,
  tableData,
  visibleCompetitorsInCommon,
  totals,
  setVisibleCompetitorsInCommon,
}) => {
  return (
    <div className={styles.desktop}>
      <table>
        <tbody>
          <tr>
            <th className={styles.emptyCell} />
            <th colSpan={2} className={styles.player1}>
              {players[0].fullName}
            </th>
            <th colSpan={2} className={styles.player2}>
              {players[1].fullName}
            </th>
          </tr>
          <tr className={` ${styles.winLossHeader}`}>
            <th className={styles.playerCol}>{i18n.t('strCommonCompetitors.player')}</th>
            <th className={styles.statHeader}>{i18n.t('strCommonCompetitors.winLoss')}</th>
            <th className={`${styles.statHeader} ${styles.borderRight}`}>
              {i18n.t('strCommonCompetitors.winPercent')}
            </th>
            <th className={styles.statHeader}>{i18n.t('strCommonCompetitors.winLoss')}</th>
            <th className={styles.statHeader}>{i18n.t('strCommonCompetitors.winPercent')}</th>
          </tr>
          {tableData.slice(0, visibleCompetitorsInCommon).map(c => {
            return (
              <tr key={c.id} className={styles.commonCompetitorRow}>
                <td className={styles.playerCol}>
                  {isPlayerHidden(c) ? (
                    <OptedOutPlayer player={c} />
                  ) : (
                    <a
                      href={getProfileUrl(c.id)}
                      className={`${styles.competitor} ${h2hStyles.greenLink}`}
                    >
                      <Flag alpha3={c.countryCode} />{' '}
                      <span className={styles.fullName}>{c.fullName}</span>{' '}
                      <sup className={styles.wtnRating}>{`(${
                        c.wtnSingles ||
                        (typeof c.wtnSingles === 'string' && c.isRanked
                          ? i18n.t('strData.pro')
                          : i18n.t('strData.na'))
                      })`}</sup>
                    </a>
                  )}
                </td>
                <td className={styles.statHeader}>{`${c.p1Loss}-${c.p1Win}`}</td>
                <td className={`${styles.borderRight} ${styles.statHeader}`}>{`${c.p1WinPc}%`}</td>
                <td className={styles.statHeader}>{`${c.p2Loss}-${c.p2Win}`}</td>
                <td className={styles.statHeader}>{`${c.p2WinPc}%`}</td>
              </tr>
            )
          })}
          <tr className={`${styles.commonCompetitorRow} ${styles.totals}`}>
            <th className={styles.playerCol}>{i18n.t('strCommonCompetitors.totals')}</th>
            <td className={styles.statHeader}>{`${totals.p1TotalLoss}-${totals.p1TotalWin}`}</td>
            <td
              className={`${styles.borderRight} ${styles.statHeader}`}
            >{`${totals.p1TotalWinPc}%`}</td>
            <td className={styles.statHeader}>{`${totals.p2TotalLoss}-${totals.p2TotalWin}`}</td>
            <td className={styles.statHeader}>{`${totals.p2TotalWinPc}%`}</td>
          </tr>
        </tbody>
      </table>
      {tableData.length > visibleCompetitorsInCommon && (
        <div className={styles.btnWrapper}>
          <button
            className={styles.showMoreBtn}
            onClick={() => {
              setVisibleCompetitorsInCommon(visibleCompetitorsInCommon + 10)
            }}
          >
            {i18n.t('strCommonCompetitors.showMore')}
          </button>{' '}
        </div>
      )}
    </div>
  )
}

export default H2HCommonCompetitorsDesktop
